export default __webpack_public_path__ + "static/media/checked.81633826.svg";